import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import { add, min } from 'lodash';
import { yearNames } from '../const/constant';

const EditSalary = ({ editType, isShow, editSalary, onChangeFunc, saveFunc, toggleFunc}) => {
  //const [selectDate, setDate] = useState(editInformation.takeOfficeDate);


  const {
    realName, 
    jobTypeId, 
    isPartTime,
    jobType, 
    date,
    baseSalary,
    fullAttendance,
    performanceBonus,
    dutyAllowance,
    foodAllowance,
    freeTaxOverTime,
    bonus,
    healthInsurance,
    laborInsurance,
    tax,
    replenishHealthInsurance,
    lateSalary,
    incomeAmt,
    deductionAmt,
    actuallyPaidAmt,
    retirementPay,
    losePunch,
    notes,
    pay,
    workingHours,
    personalLeaveSalary,
    sickLeaveSalary,
    pointSalary,
    otherAllowance,
    managerAllowance,
    selfPension,
    otherDeduction,
    supplementaryPremium
  } = editSalary;

  const addAmt = (
    isPartTime ? 
    (pay*workingHours) + freeTaxOverTime + bonus + fullAttendance + performanceBonus + dutyAllowance+ foodAllowance+ otherAllowance : 
    baseSalary + freeTaxOverTime + bonus + fullAttendance + performanceBonus + dutyAllowance+ foodAllowance+ otherAllowance
  )
  const minusAmt = (
    healthInsurance+laborInsurance+lateSalary+sickLeaveSalary+pointSalary+personalLeaveSalary+selfPension+otherDeduction+supplementaryPremium+retirementPay
  )

  const actualGet = (
    Math.round(addAmt) - Math.round(minusAmt)
  )

  return (
    <div className="u-editblock fadeIn" style={{display: isShow === true ? 'flex' : 'none'}}>
      <div className="form-block" style={{minWidth:'400px'}}>
        <div className="u-small-title">{editType === 'ADD' ? '新增' : '編輯'}薪資單</div>
        <form className="u-form">
          <div className="row m-t-16">
            <div className="col-6">
              <label className="u-form__label text-align-right">年份：</label>
              <select onChange={(e)=>{onChangeFunc('year', e);}} value={date.format('YYYY')} name="year" id="year"className="u-form__select" >
              {
                yearNames.map(yearName => (
                  <option key={yearName} value={yearName}>{ yearName }</option>
                ))
              }
              </select>
            </div>
            <div className="col-6">
                <label className="u-form__label text-align-right">月份：</label>
                <select onChange={(e)=>{onChangeFunc('month', e);}} value={date.month()} name="month" id="month"className="u-form__select" >
              <option value="0">01</option>
              <option value="1">02</option>
              <option value="2">03</option>
              <option value="3">04</option>
              <option value="4">05</option>
              <option value="5">06</option>
              <option value="6">07</option>
              <option value="7">08</option>
              <option value="8">09</option>
              <option value="9">10</option>
              <option value="10">11</option>
              <option value="11">12</option>
              </select>
              </div>
          </div>
          <div className="row m-t-16">
            <div className="col-6">
              <label className="u-form__label text-align-right">姓名：{realName}</label>
            </div>
            <div className="col-6">
                <label className="u-form__label text-align-right">職位：{jobType}</label>
            </div>
          </div>
          <div className="row">
          {

              <div className="col-6">
                <label className="u-form__label text-align-right">基本月薪：</label>
                <input type='number' value={baseSalary || 0} onChange={(e)=>{onChangeFunc('baseSalary', e);}} className="u-form__input underline"/>
              </div>
          }
            <div className="col-6">
              <label className="u-form__label text-align-right">代扣勞保費：</label>
              <input type='number' value={laborInsurance || 0} onChange={(e)=>{onChangeFunc('laborInsurance', e);}} className="u-form__input underline"/>
            </div>
          </div>
          <div className="row">

              <div className="col-6">
              <label className="u-form__label text-align-right">時薪(兼職)：</label>
              <input type='number' value={pay || 0} onChange={(e)=>{onChangeFunc('pay', e);}} className="u-form__input underline"/>
            </div>
            <div className="col-6">
              <label className="u-form__label text-align-right">代扣健保費：</label>
              <input type='number' value={healthInsurance || 0} onChange={(e)=>{onChangeFunc('healthInsurance', e);}} className="u-form__input underline"/>
            </div>

          </div>
          {isPartTime ?
          <div className="row">
          
              
              <>

              <div className="col-6">
              <label className="u-form__label text-align-right">時數(兼職)：</label>
              <input type='number'  step="0.01" value={workingHours || 0} onChange={(e)=>{onChangeFunc('workingHours', e);}} className="u-form__input underline"/>
            </div>
            </>
              
              <div className="col-6">
              <label className="u-form__label text-align-right">二代健保：</label>
              <input type='number' value={supplementaryPremium || 0} onChange={(e)=>{onChangeFunc('supplementaryPremium', e);}} className="u-form__input underline"/>
            </div>
          
          </div>:          <div className="row">
          
              
          <>

          <div className="col-6">
          <label className="u-form__label text-align-right">時數(兼職)：</label>
          <input type='number'  step="0.01"  value={workingHours || 0} onChange={(e)=>{onChangeFunc('workingHours', e);}} className="u-form__input underline"/>
        </div>
        </>
          
          <div className="col-6">
          <label className="u-form__label text-align-right">二代健保：</label>
              <input type='number' value={supplementaryPremium || 0} onChange={(e)=>{onChangeFunc('supplementaryPremium', e);}} className="u-form__input underline"/>
        </div>
      

      </div>
          }
          <div className="row">
            <div className="col-6">
              <label className="u-form__label text-align-right">免稅加班：</label>
              <input type='number' value={freeTaxOverTime || 0} onChange={(e)=>{onChangeFunc('freeTaxOverTime', e);}} className="u-form__input underline"/>
            </div>
            <div className="col-6">
              <label className="u-form__label text-align-right">遲到扣款：</label>
              <input type='number' value={lateSalary || 0} onChange={(e)=>{onChangeFunc('lateSalary', e);}} className="u-form__input underline"/>
            </div>
          </div>
          <div className="row">
          <div className="col-6">
              <label className="u-form__label text-align-right">禮金：</label>
              <input type='number' value={bonus || 0} onChange={(e)=>{onChangeFunc('bonus', e);}} className="u-form__input underline"/>
            </div>
            <div className="col-6">
              <label className="u-form__label text-align-right">病假扣款：</label>
              <input type='number' value={sickLeaveSalary || 0} onChange={(e)=>{onChangeFunc('sickLeaveSalary', e);}} className="u-form__input underline"/>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <label className="u-form__label text-align-right">全勤加給：</label>
              <input type='number' value={fullAttendance || 0} onChange={(e)=>{onChangeFunc('fullAttendance', e);}} className="u-form__input underline"/>
            </div>
            <div className="col-6">
              <label className="u-form__label text-align-right">所得稅：</label>
              <input type='number' value={pointSalary || 0} onChange={(e)=>{onChangeFunc('pointSalary', e);}} className="u-form__input underline"/>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <label className="u-form__label text-align-right">獎金：</label>
              <input type='number' value={performanceBonus || 0} onChange={(e)=>{onChangeFunc('performanceBonus', e);}} className="u-form__input underline"/>
            </div>
            <div className="col-6">
              <label className="u-form__label text-align-right">事假扣款：</label>
              <input type='number' value={personalLeaveSalary || 0} onChange={(e)=>{onChangeFunc('personalLeaveSalary', e);}} className="u-form__input underline"/>
            </div>
          </div>
          <div className="row">
          <div className="col-6">
              <label className="u-form__label text-align-right">職務津貼：</label>
              <input type='number' value={dutyAllowance || 0} onChange={(e)=>{onChangeFunc('dutyAllowance', e);}} className="u-form__input underline"/>
            </div>
            <div className="col-6">
              <label className="u-form__label text-align-right">漏打卡次數：</label>
              <input type='number' disabled value={losePunch || 0} className="u-form__input underline"/>
            </div>
          </div>
          <div className="row">
          <div className="col-6">
              <label className="u-form__label text-align-right">伙食津貼：</label>
              <input type='number' value={foodAllowance || 0} onChange={(e)=>{onChangeFunc('foodAllowance', e);}} className="u-form__input underline"/>
            </div>
            <div className="col-6">
              <label className="u-form__label text-align-right">自提勞退：</label>
              <input type='number' value={selfPension || 0} onChange={(e)=>{onChangeFunc('selfPension', e);}} className="u-form__input underline"/>
            </div>
          </div>
          <div className="row">
          <div className="col-6">
              <label className="u-form__label text-align-right">其他：</label>
              <input type='number' value={otherAllowance || 0} onChange={(e)=>{onChangeFunc('otherAllowance', e);}} className="u-form__input underline"/>
            </div>
            <div className="col-6">
              <label className="u-form__label text-align-right">其他扣款：</label>
              <input type='number' value={otherDeduction || 0} onChange={(e)=>{onChangeFunc('otherDeduction', e);}} className="u-form__input underline"/>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <label className="u-form__label text-align-right">加項薪資：</label>
              <input type='number' disabled value={Math.round(addAmt) || workingHours*pay} className="u-form__input underline"/>
            </div>
            <div className="col-6">
              <label className="u-form__label text-align-right">減項薪資：</label>
              <input type='number' disabled value={Math.round(minusAmt) || 0} className="u-form__input underline"/>
            </div>
          </div>          <div className="row">
            <div className="col-6">
              <label className="u-form__label text-align-right">實領薪資：</label>
              <input type='number' disabled value={actualGet < 0? (workingHours*pay)-minusAmt:actualGet} className="u-form__input underline"/>
            </div>
            <div className="col-6">
              <label className="u-form__label text-align-right">公司退提：</label>
              <input type='number' value={retirementPay || 0} min="0" onChange={(e)=>{onChangeFunc('retirementPay', e);}} className="u-form__input underline"/>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <label className="u-form__label text-align-right">備註：</label>
              <input value={notes || ''} onChange={(e)=>{onChangeFunc('notes', e);}} className="u-form__input underline"/>
            </div>
          </div>
          <div className="u-btn-group right">
            <button className="btn btn-md save" onClick={(e) => {
              e.preventDefault();
              saveFunc();
            }}>儲存</button>
            <button className="btn btn-md cancel m-l-16" onClick={
              (e) => {
                e.preventDefault();
                toggleFunc();
              }
            }>取消</button>
          </div>
        </form>
      </div>
    </div>
  )

}

export default EditSalary;